<template>
  <body>
    <div class="h-full d-flex" id="wrapper">
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav
          class="navbar navbar-expand-lg navbar-light border-bottom">
          <router-link to="/" class="menu-item menu-link-main custom-logo-link"
            id="imagen"
            rel="home"
            aria-current="page"
          >
            <img
              width="410"
              height="60"
              src="../assets/LogoH35-02.png"
              class="custom-logo container-fluid"
              alt="Ya llego Logo"
              style="position: relative; z-index: 3;"
              sizes="(max-width: 410px) 100vw, 410px"
            />
          </router-link>

          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="ocultarHeader"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div
            class="navbar-collapse collapse"
            id="navbarSupportedContent"
            style
          >
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item active">
                <router-link v-show="!logueado" to="/login"
                  ><a class="nav-link text-white"
                    ><b-icon
                      icon="person-fill"
                      aria-hidden="true"
                    ></b-icon>
                    Iniciar sesión</a
                  ></router-link
                >
              </li>
              <li v-show="!logueado" class="nav-item">
                <router-link to="/registrarse"
                  ><a class="nav-link text-white"
                    ><b-icon
                      icon="person-plus-fill"
                      aria-hidden="true"
                    ></b-icon>
                    Registrarse</a
                  ></router-link
                >
              </li>
              <li class="nav-item" v-show="logueado">
                <router-link to="/"
                  ><a class="nav-link text-white"
                    ><b-icon icon="list-ul" aria-hidden="true"></b-icon>
                    Menu</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/rastrear-pedido"
                  ><a class="nav-link text-white"
                    ><b-icon icon="geo-alt-fill" aria-hidden="true"></b-icon>
                    Rastrea tu pedido</a
                  ></router-link
                >
              </li>
              <li class="nav-item dropdown" v-show="logueado">
                <a  class="nav-link dropdown-toggle text-white" href="#" id="navbarDropdown" data-toggle="dropdown" aria-expanded="false" @click="ocultarOpciones">
                  <b-icon icon="person-fill"></b-icon>
                  {{ this.$store.state.user_name }}
                </a>
                <div id="dropdown" class="dropdown-menu dropdown-menu-right  text-dark" aria-labelledby="navbarDropdown">
                  <router-link to="/cambiar-contrasena">
                    <a class="nav-link text-dark"><b-icon icon="lock-fill" aria-hidden="true"></b-icon>Cambiar contraseña</a>
                  </router-link>
                  <a class="nav-link" @click="logout" href="#">
                    <b-icon icon="box-arrow-in-right" aria-hidden="true"></b-icon> Cerrar sesión
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <main class="main container-fluid">
          <slot />
        </main>
      </div>
      <!-- /#page-content-wrapper -->
    </div>
    <!-- /#wrapper -->
  </body>
</template>

<script>
import { logear } from "../plugins/conn";
export default {
  data() {
    return {
      submitted: false,
      password: ""
    };
  },
  computed: {
    logueado() {
      return this.$store.getters.loggedIn;
    },
  },
  methods: {
    ocultarHeader() {
      document
        .getElementById("navbarSupportedContent")
        .classList.toggle("show");
    },
    ocultarOpciones() {
      document.getElementById("dropdown").classList.toggle("show");
    },
    logout() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("token_type");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_name");
      localStorage.removeItem("cliente_id");
      localStorage.removeItem("datosUsuario");
      localStorage.removeItem("datosCliente");
      localStorage.removeItem("tokensExpiry");
      this.$cookies.remove("clienteId");
      window.location.href = `${process.env.VUE_APP_URL}/`;
    },
    showModal() {
      this.submitted = true;
      this.password = "";
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.submitted = false;
      this.$refs["my-modal"].hide();
    },
    loggedIn() {
      this.submitted = true;
      logear(this.password, this.$store, this.$cookies, this.$swal, this.$refs["my-modal"]);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  min-height: 100%;
}
.h-full{
  max-height: unset;
  height: 100%;
  min-height: 100vh;
}
a{
  text-decoration: none !important;
}
.letra {
  color: #000 !important;
}

.dropdown-item:active ,.dropdown-item:hover{
  background-color: #043367;
  color: #fff !important;
  transition: color 0.3s ease;
}
.navbar-toggler {
  background-color: #fff !important;
}
a#imagen {
  position: relative;
}
a img{
  position: relative;
  z-index: 1;
}
a#imagen::before {
  content: "";
  position: absolute;
  top: -15px;
  left: -30px;
  width: 150%;
  height: calc(100% + 1.5rem);
  background: white;
  transform: skew(-20deg);
  z-index: 2;
}

#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}
#dropdown .nav-link:hover{
  background-color: var(--secondary-color);
  color: #fff !important;
}
@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }
  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }
  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
</style>
